// extracted by mini-css-extract-plugin
export var dropdownButton = "_3y-0";
export var fullWidthDropdownButton = "_3y-1";
export var icon = "_3y-3";
export var iconPlaceholder = "_3y-2";
export var menuItemRow = "_3y-8";
export var separator = "_3y-c";
export var shortcutContainer = "_3y-7";
export var shortcutIconLg = "_3y-6";
export var shortcutIconMd = "_3y-5";
export var shortcutIconSm = "_3y-4";
export var submenuChevron = "_3y-b";
export var submenuDropdown = "_3y-9";
export var submenuTriggerRow = "_3y-a";